import store from '@state/store'
import { Role } from '@state/helpers'

export default [{
        path: '/',
        name: 'home',
        component: () => lazyLoadView(
            import ('@views/home')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
    },
    {
        path: '/login',
        name: 'login',
        component: () => lazyLoadView(
            import ('@views/login')),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {

                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forget-password',
        name: 'forget-password',
        component: () => lazyLoadView(
            import ('@views/forgetPassword')),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: false,
            beforeResolve(routeTo, routeFrom, next) {
                store.dispatch('auth/logOut');
                next({ name: 'login' });

            },
        },
    },
    {
        path: '/404',
        name: '404',
        component: require('@views/_404').default,
        // Allows props to be passed to the 404 page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
    },
    {
        path: '/403',
        name: '403',
        component: require('@views/_403').default,
        // Allows props to be passed to the 404 page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: '*',
        redirect: '404',
    },
    {
        path: '/500',
        name: 'Error500',
        component: () => lazyLoadView(
            import ('@views/errors/error500'))
    },
    {
        path: '/organismos/organismos/:exito?',
        name: 'organismos',
        component: () => lazyLoadView(
            import ('@views/organismos/organismos')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/organismos/add',
        name: 'agregar organismos',
        component: () => lazyLoadView(
            import ('@views/organismos/add')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/organismos/edit/:id',
        name: 'editar-organismos',
        component: () => lazyLoadView(
            import ('@views/organismos/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/metadatos/metadatos/:exito?',
        name: 'metadatos',
        component: () => lazyLoadView(
            import ('@views/metadatos/metadatos')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/metadatos/addMetadato',
        name: 'agregar Metadato',
        component: () => lazyLoadView(
            import ('@views/metadatos/addMetadato')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/metadatos/editMetadato/:id',
        name: 'editar-metadatos',
        component: () => lazyLoadView(
            import ('@views/metadatos/editMetadato')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/usuarios/',
        name: 'Listado_Usuarios',
        component: () => lazyLoadView(
            import ('@views/usuarios/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/usuarios/add',
        name: 'Add_Usuarios',
        component: () => lazyLoadView(
            import ('@views/usuarios/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/usuarios/edit/:idUsuario',
        name: 'editar_usuario',
        component: () => lazyLoadView(
            import ('@views/usuarios/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/cuenta/',
        name: 'Informacion_Cuenta',
        component: () => lazyLoadView(
            import ('@views/usuarios/account')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/usuarios/index/:exito?',
        name: 'Lista_Usuarios',
        component: () => lazyLoadView(
            import ('@views/usuarios/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },


    {
        path: '/contribuyentes/index/:exito?',
        name: 'Lista_Contribuyentes',
        component: () => lazyLoadView(
            import ('@views/contribuyentes/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/contribuyentes/add',
        name: 'Agregar_Contribuyentes',
        component: () => lazyLoadView(
            import ('@views/contribuyentes/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/contribuyentes/edit/:id',
        name: 'editar_contribuyentes',
        component: () => lazyLoadView(
            import ('@views/contribuyentes/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/listas/listas/:exito?',
        name: 'Lista',
        component: () => lazyLoadView(
            import ('@views/listas/listas')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/listas/addLista',
        name: 'agregar_Listas',
        component: () => lazyLoadView(
            import ('@views/listas/addLista')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/listas/edit/:idLista',
        name: 'editar_lista',
        component: () => lazyLoadView(
            import ('@views/listas/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/tipoDocumento/index/:exito?',
        name: 'Listado_Tipo_Documentos',
        component: () => lazyLoadView(
            import ('@views/tipoDocumento/index')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/tipoDocumento/add',
        name: 'agregar_tipo_documentos',
        component: () => lazyLoadView(
            import ('@views/tipoDocumento/add')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/tipoDocumento/edit/:idTipoDocumento',
        name: 'editar_tipo_documentos',
        component: () => lazyLoadView(
            import ('@views/tipoDocumento/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Administrador, Role.Operador]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/documentos/add',
        name: 'add_documentos',
        component: () => lazyLoadView(
            import ('@views/documentos/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/documentos/exito',
        name: 'exito_documento',
        component: () => lazyLoadView(
            import ('@views/documentos/exito')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/documentos/consulta',
        name: 'consulta_documento',
        component: () => lazyLoadView(
            import ('@views/documentos/consulta')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/documentos/validacion',
        name: 'validacion_documento',
        component: () => lazyLoadView(
            import ('@views/documentos/validacion')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/documentos/edit/:id',
        name: 'editar_documento',
        component: () => lazyLoadView(
            import ('@views/documentos/editardocumento')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/solicitudCopia/solicituCopia/:exito?',
        name: 'solicitud_Copia',
        component: () => lazyLoadView(
            import ('@views/solicitudCopia/solicituCopia')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/cuentas/',
        name: 'Listado_cuentas',
        component: () => lazyLoadView(
            import ('@views/cuentas/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/cuentas/add',
        name: 'Add_cuentas',
        component: () => lazyLoadView(
            import ('@views/cuentas/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/cuentas/edit/:id',
        name: 'editar_cuenta',
        component: () => lazyLoadView(
            import ('@views/cuentas/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/cuentas/index/:exito?',
        name: 'Lista_Cuentas',
        component: () => lazyLoadView(
            import ('@views/cuentas/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/categorias/',
        name: 'Listado_categorias',
        component: () => lazyLoadView(
            import ('@views/categorias/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/categorias/add',
        name: 'Add_categorias',
        component: () => lazyLoadView(
            import ('@views/categorias/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/categorias/edit/:id',
        name: 'editar_categorias',
        component: () => lazyLoadView(
            import ('@views/categorias/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },    
    {
        path: '/categorias/index/:exito?',
        name: 'Lista_categorias',
        component: () => lazyLoadView(
            import ('@views/categorias/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/subcategorias/',
        name: 'Listado_subcategorias',
        component: () => lazyLoadView(
            import ('@views/subcategorias/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/subcategorias/index/:exito?',
        name: 'Lista_subcategorias',
        component: () => lazyLoadView(
            import ('@views/subcategorias/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/subcategorias/add',
        name: 'Add_subcategorias',
        component: () => lazyLoadView(
            import ('@views/subcategorias/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/subcategorias/edit/:id',
        name: 'editar_subcategorias',
        component: () => lazyLoadView(
            import ('@views/subcategorias/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/conceptos/',
        name: 'Listado_conceptos',
        component: () => lazyLoadView(
            import ('@views/conceptos/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/conceptos/index/:exito?',
        name: 'Lista_conceptos',
        component: () => lazyLoadView(
            import ('@views/conceptos/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/conceptos/add',
        name: 'Add_conceptos',
        component: () => lazyLoadView(
            import ('@views/conceptos/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/conceptos/edit/:id',
        name: 'editar_conceptos',
        component: () => lazyLoadView(
            import ('@views/conceptos/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/pagos/add',
        name: 'Add_pagos',
        component: () => lazyLoadView(
            import ('@views/pagos/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/pagos4/add',
        name: 'Add_pagos4',
        component: () => lazyLoadView(
            import ('@views/pagos4/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/licencias/add',
        name: 'Add_licencias',
        component: () => lazyLoadView(
            import ('@views/licencias/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/licencias/',
        name: 'Listado_licencias',
        component: () => lazyLoadView(
            import ('@views/licencias/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/licencias/index/:exito?',
        name: 'Lista_licencias',
        component: () => lazyLoadView(
            import ('@views/licencias/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/facturacion/',
        name: 'Listado_facturacion',
        component: () => lazyLoadView(
            import ('@views/facturacion/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/complemento/',
        name: 'Listado_complemento',
        component: () => lazyLoadView(
            import ('@views/complemento/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/complemento/add/:id',
        name: 'crear_complemento',
        component: () => lazyLoadView(
            import ('@views/complemento/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/reportes/contribuyente',
        name: 'Listado_contribuyente',
        component: () => lazyLoadView(
            import ('@views/reportes/contribuyente')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/reportes/contribuyenteconceptos',
        name: 'Listado_contribuyente_conceptos',
        component: () => lazyLoadView(
            import ('@views/reportes/contribuyenteconcepto')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/reportes/contribuyenteconceptos_s',
        name: 'Listado_contribuyente_s',
        component: () => lazyLoadView(
            import ('@views/reportes/contribuyenteconceptos')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/reportes/diario',
        name: 'Listado_diario',
        component: () => lazyLoadView(
            import ('@views/reportes/diario')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/reportes/usuario',
        name: 'Listado_usuario',
        component: () => lazyLoadView(
            import ('@views/reportes/usuario')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/reportes/categorias',
        name: 'reportes_categorias',
        component: () => lazyLoadView(
            import ('@views/reportes/categoria')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/reportes/conceptos',
        name: 'Listado_concepto',
        component: () => lazyLoadView(
            import ('@views/reportes/concepto')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/certificado/',
        name: 'Listado_certificado',
        component: () => lazyLoadView(
            import ('@views/certificado/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/certificado/index/:exito?',
        name: 'Lista_certificado',
        component: () => lazyLoadView(
            import ('@views/certificado/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/certificado/add',
        name: 'Add_certificado',
        component: () => lazyLoadView(
            import ('@views/certificado/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/cajas/',
        name: 'Listado_cajas',
        component: () => lazyLoadView(
            import ('@views/cajas/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/cajas/index/:exito?',
        name: 'Lista_cajas',
        component: () => lazyLoadView(
            import ('@views/cajas/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/cajas/add',
        name: 'Add_cajas',
        component: () => lazyLoadView(
            import ('@views/cajas/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/cajas/edit/:id',
        name: 'editar_cajas',
        component: () => lazyLoadView(
            import ('@views/cajas/edit')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/polizas/add',
        name: 'Add_polizas',
        component: () => lazyLoadView(
            import ('@views/polizas/add')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/polizas/',
        name: 'Listado_polizas',
        component: () => lazyLoadView(
            import ('@views/polizas/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },
    {
        path: '/polizas/index/:exito?',
        name: 'Lista_polizas',
        component: () => lazyLoadView(
            import ('@views/polizas/index')),
        meta: {
            authRequired: true,
            roles: [Role.Todos]
        },
        props: (route) => ({ user: store.state.auth.currentUser || {} })
    },

]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
    const AsyncHandler = () => ({
        component: AsyncView,
        // A component to use while the component is loading.
        loading: require('@views/_loading').default,
        // Delay before showing the loading component.
        // Default: 200 (milliseconds).
        delay: 200,
        // A fallback component in case the timeout is exceeded
        // when loading the component.
        error: require('@views/_timeout').default,
        // Time before giving up trying to load the component.
        // Default: Infinity (milliseconds).
        timeout: 10000,
    })

    return Promise.resolve({
        functional: true,
        render(h, { data, children }) {
            // Transparently pass any props or children
            // to the view component.
            return h(AsyncHandler, data, children)
        },
    })
}